import { css } from '@emotion/core'
import { marginTop } from 'assets/styles/global'

export const partnershipSectionContainer = css`
  margin-top: 5rem;
`

export const marginTop30 = marginTop(30)
